export const routes = {
    auth: {
        totp: {
            href: () => '/auth/totp',
            path: 'auth/totp',
        },
    },
    changelogs: {
        href: () => '/changelogs',
        path: 'changelogs',
    },
    developer: {
        applications: {
            href: () => '/developer/applications',
            path: 'developer/applications',
        },
    },
    forgotPassword: {
        href: () => '/forgot-password',
        path: 'forgot-password',
    },
    generators: {
        reverseRoulette: {
            href: () => '/generators/reverse-roulette',
            path: 'reverse-roulette',
        },
        tierRoulette: {
            href: () => '/generators/tier-roulette',
            path: 'tier-roulette',
        },
    },
    platformerList: {
        href: () => '/platformer-list',
        path: 'platformer-list',
    },
    submit: {
        href: () => '/submit',
        path: 'submit',
        level: {
            href: (levelID: number) => `/submit/${levelID}`,
            path: 'submit/:levelID',
        },
    },
    staff: {
        href: () => '/mod',
        achievements: {
            href: () => '/mod/achievements',
            path: 'achievements',
            withId: {
                href: (achievementId: number) => `/mod/achievements/${achievementId}`,
                path: 'achievements/:achievementId',
            },
        },
        addLevel: {
            href: () => '/mod/add-level',
            path: 'add-level',
        },
        addSubmission: {
            href: () => '/mod/add-submission',
            path: 'add-submission',
        },
        createUser: {
            href: () => '/mod/create-user',
            path: 'create-user',
        },
        crossroadsPack: {
            href: () => '/mod/crossroads-pack',
            path: 'crossroads-pack',
        },
        deleteUser: {
            href: () => '/mod/delete-user',
            path: 'delete-user',
        },
        editPack: {
            href: () => '/mod/edit-pack',
            path: 'edit-pack',
            withId: {
                href: (packId: number) => `/mod/edit-pack/${packId}`,
                path: 'edit-pack/:packId',
            },
        },
        editSubmission: {
            href: (id: number) => '/mod/edit-submission/' + id,
            path: 'edit-submission/:submissionID',
        },
        editTags: {
            href: () => '/mod/edit-tags',
            path: 'edit-tags',
        },
        manageUser: {
            href: () => '/mod/manage-user',
            path: 'manage-user',
            withId: {
                href: (userId: number) => `/mod/manage-user/${userId}`,
                path: ':userID',
            },
        },
        mergeSubmissions: {
            href: () => '/mod/merge-submissions',
            path: 'merge-submissions',
        },
        signupLinks: {
            href: () => '/mod/signup-links',
            path: 'signup-links',
        },
        siteSettings: {
            href: () => '/mod/site-settings',
            path: 'site-settings',
        },
        sparkyPack: {
            href: () => '/mod/sparky-pack',
            path: 'sparky-pack',
        },
        gddlpPack: {
            href: () => '/mod/gddlp-pack',
            path: 'gddlp-pack',
        },
        submissions: {
            search: {
                href: () => '/mod/submission-search',
                path: 'submission-search',
            },
        },
    },
} as const;
